import React, {forwardRef, useImperativeHandle, useMemo, useRef, useState} from 'react';
import Overlay from 'src/components/overlay';
import IconButton from 'src/autobahn/components/button/icon-button';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

const DeviceImagesOverlay = forwardRef(({images}, ref) => {
    const intl = useIntl();

    const [open, setOpen] = useState(false);

    const sliderRef = useRef(null);

    const [selectedDeviceImage, selectDeviceImage] = useState(null);

    const selectedDeviceImageIndex = useMemo(() =>
        images.findIndex((file) => file === selectedDeviceImage),
[selectedDeviceImage, images]);

    const closeOverlay = () => {
        setOpen(false);
    };

    const snapDeviceImagesSlideToLeft = () => {
        if (selectedDeviceImageIndex <= 0) return;

        const nextIndex = selectedDeviceImageIndex - 1;

        selectDeviceImage(images[nextIndex]);
        sliderRef.current.scrollTo({left: sliderRef.current.offsetWidth * nextIndex, behavior: 'smooth'});
    };

    const snapDeviceImagesSlideToRight = () => {
        if (selectedDeviceImageIndex >= images.length -1) return;

        const nextIndex = selectedDeviceImageIndex + 1;

        selectDeviceImage(images[nextIndex]);
        sliderRef.current.scrollTo({left: sliderRef.current.offsetWidth * nextIndex, behavior: 'smooth'});
    };

    useImperativeHandle(ref, () => ({
        open(image) {
            selectDeviceImage(image);
            const imageIndex = images.findIndex((img) => img === image);
            sliderRef.current.scrollTo({left: sliderRef.current.offsetWidth * imageIndex, behavior: 'instant'});
            setOpen(true);
    },
    }), [images]);

    return (
        <Overlay open={open}>
            <div style={{display: 'flex', flexDirection: 'column', flexGrow: 0, padding: 24, backgroundColor: '#fff', width: '40%', boxShadow: '2px 4px 16px 0px #00000026', borderRadius: '12px'}}>
                <div style={{display: 'flex', flexDirection: 'row', alignSelf: 'stretch', justifyContent: 'space-between'}}>
                    <span style={{
                        fontFamily: 'Inter',
                        fontWeight: 700,
                        lineHeight: '21px',
                        fontSize: '18px',
                        color: '#16A5DA',
                    }}>{intl.formatMessage({id: 'deviceImage'})}</span>
                    <IconButton
                        className='overlay__close-btn'
                        onClick={closeOverlay}
                    >
                        <i className="fal fa-times fa-lg"></i>
                    </IconButton>

                </div>

                <div className='device-images-slider' ref={sliderRef}>
                    {images.map((img) => (
                        <div key={`${img.id}_slide`} className='device-images-slider__slide'>
                            <img className='device-images-slider__slide__image' src={img.preview} />
                        </div>
                    ))}
                </div>

                <div style={{display: 'flex', flexGrow: 0, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                    <IconButton
                        className='slider__nav-button'
                        onClick={snapDeviceImagesSlideToLeft}
                        data-disabled={selectedDeviceImageIndex === 0}
                        disabled={selectedDeviceImageIndex === 0}
                        style={{marginRight: '32px'}}
                    >
                        <i className="fas fa-chevron-left fa-lg" color="inherit"></i>
                    </IconButton>

                    <div style={{display: 'flex', flexGrow: 0, flexDirection: 'row', columnGap: '16px'}}>
                        {images.map((img) => {
                            const selected = img === selectedDeviceImage;

                            return (
                                <div key={`${img.id}_indicator`} className="slider__nav-indicator" data-active={selected} />
                            );
                        })}
                    </div>

                    <IconButton
                        className='slider__nav-button'
                        onClick={snapDeviceImagesSlideToRight}
                        data-disabled={selectedDeviceImageIndex === images.length - 1}
                        disabled={selectedDeviceImageIndex === images.length - 1}
                        style={{marginLeft: '32px'}}
                    >
                        <i className="fas fa-chevron-right fa-lg" color="inherit"></i>
                    </IconButton>
                </div>
            </div>
        </Overlay>
    );
});

DeviceImagesOverlay.displayName = 'DeviceImagesOverlay';

DeviceImagesOverlay.propTypes = {
    images: PropTypes.arrayOf(PropTypes.instanceOf(File)),
};

export default DeviceImagesOverlay;
